import { createApp } from "vue";
import App from "./App.vue";
import "./styles/media.scss";

createApp(App).mount("#app");
